import React from 'react';
import { Card, Table, Button, Tag, Space } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supplierAdvanceRequestService } from '@/services/supplierAdvanceRequest.service';
import { EnterprisePageHeader } from '@/components/enterprise';
import { DocumentRefLink } from '@/components/DocumentRefLink';

const statusColors: Record<string, string> = {
  Draft: 'default',
  Submitted: 'blue',
  'Pending Approval': 'orange',
  Approved: 'green',
  Rejected: 'red',
  'Partially Paid': 'cyan',
  'Fully Paid': 'green',
  Cancelled: 'red',
};

const SupplierAdvanceRequestsPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const poFilter = searchParams.get('purchase_order_id') ?? undefined;
  const { data: rows = [], isLoading } = useQuery({
    queryKey: ['supplier-advance-requests', poFilter],
    queryFn: () => supplierAdvanceRequestService.list({ purchase_order_id: poFilter }),
  });

  return (
    <div>
      <EnterprisePageHeader documentLabel="Supplier advance requests" documentNumber="" />
      <Card>
        <Table
          loading={isLoading}
          rowKey="id"
          dataSource={rows}
          onRow={(r) => ({ onClick: () => navigate(`/scm/procurement/supplier-advance-requests/${r.id}`), style: { cursor: 'pointer' } })}
          columns={[
            { title: 'Request #', dataIndex: 'advance_request_number' },
            {
              title: 'PO',
              render: (_, r) => (
                <DocumentRefLink
                  to={`/scm/procurement/purchase-orders/${r.purchase_order_id}`}
                  number={r.purchaseOrder?.po_number}
                  id={r.purchase_order_id}
                />
              ),
            },
            { title: 'Supplier', render: (_, r) => r.supplier?.supplier_name ?? '—' },
            { title: 'Requested', dataIndex: 'requested_amount', render: (v: number, r) => `${r.currency} ${Number(v).toFixed(2)}` },
            { title: 'Paid', dataIndex: 'paid_amount', render: (v: number) => Number(v).toFixed(2) },
            { title: 'Status', dataIndex: 'status', render: (s: string) => <Tag color={statusColors[s] ?? 'default'}>{s}</Tag> },
            {
              title: '',
              render: (_, r) => (
                <Button type="link" onClick={(e) => { e.stopPropagation(); navigate(`/scm/procurement/supplier-advance-requests/${r.id}`); }}>
                  Open
                </Button>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default SupplierAdvanceRequestsPage;
